// GATE_CHECK — given the resolved tenant's self User + Account, decide the next
// state of the app-start machine. Each gate is keyed to the entity it belongs to
// (User / Account / membership) so M4 add-account & join-account flows re-enter
// at the right point.
export const GATE = {
  PROFILE: 'onboard_profile', // User.personalInfosCompleted (+ Identity password, UX-collapsed)
  ACCOUNT: 'onboard_account', // Account.accountSettings.{accountInfosCompleted,moduleSelectionCompleted}
  ACTIVATE: 'activate_membership', // User.activatedAt — screenless; flows into ACTIVE
  ACTIVE: 'active',
};

const activationGate = (user) => {
  if (user.activatedAt === null) {
    return GATE.ACTIVATE;
  }

  return GATE.ACTIVE;
};

export const gateDecision = ({ user, account }) => {
  if (user.externalId !== null) {
    return activationGate(user);
  }

  if (user.personalInfosCompleted === null) {
    return GATE.PROFILE;
  }

  if (
    user.isAccountAdmin
    && account.accountSettings !== null
    && (account.accountSettings.accountInfosCompleted === null
      || account.accountSettings.moduleSelectionCompleted === null)
  ) {
    return GATE.ACCOUNT;
  }
  return activationGate(user);
};
